import {
  isLocalDevelopmentEnvironment,
  isServerMimicMode
} from './app.environment';
import {
  APP_LOCAL_DEVELOPMENT_LOGIN_URL,
  DEFAULT_APP_LOGIN_URL,
  DEFAULT_SERVER_MIMIC_APP_LOGIN_URL,
  DOMAIN_APP_PREFIX,
  DOMAIN_APP_SUFFIX,
  REACT_AUTH_APP_LOGIN_URL
} from './app.settings.constants';
import { ApplicationConfigFile } from './app.settings.interfaces';
import * as sessionStorage from '../utility/session.storage';
import {
  AUTH_MODE_KEY,
  AUTH_MODE_REACT
} from '../utility/session.storage.keys';

/**
 * True when this tab opted into React auth via a prior successful login
 * (`invision-auth-mode=react` in sessionStorage). Used to keep logout / idle /
 * expiry on `/authentication` in environments that are not config-enabled.
 *
 * TODO(AB#1355453): Remove with the auth-mode opt-in once React auth is the
 * default in every environment.
 */
export function isReactAuthModeOptIn(): boolean {
  const mode = sessionStorage.read(AUTH_MODE_KEY);
  return typeof mode === 'string' && mode === AUTH_MODE_REACT;
}

/** Returns the login url for the application as specified in config.json, or customercare/login if not specified. */
export function getLoginUrl(configData: ApplicationConfigFile): string {
  // Check for server mimic mode first
  if (isServerMimicMode()) {
    // In server mimic mode, always redirect to the authentication module
    return DEFAULT_SERVER_MIMIC_APP_LOGIN_URL;
  }

  // Upgrade-only: when the tab opted into React auth, always use the React
  // auth app. Never downgrade an environment that already points at it.
  // TODO(AB#1355453): Remove with the auth-mode opt-in once React auth is the
  // default in every environment.
  if (isReactAuthModeOptIn()) {
    return REACT_AUTH_APP_LOGIN_URL;
  }

  // Original logic for normal modes
  const defaultLoginUrl = isLocalDevelopmentEnvironment()
    ? APP_LOCAL_DEVELOPMENT_LOGIN_URL
    : DEFAULT_APP_LOGIN_URL;

  return (configData && configData.loginUrl) || defaultLoginUrl;
}

/**
 * Get environment portion of url
 * @returns e.g. edge.ui-dbt or qa1
 */
export function getEnvironmentFromCurrentHost() {
  return getEnvironmentFromHostName(document.location.hostname);
}

/**
 * Get environment portion of url
 * @param hostname e.g. invision.edge.webarch-dbt.ascendon.tv
 * @returns e.g. edge.ui-dbt or qa1
 */
export function getEnvironmentFromHostName(hostname: string) {
  return hostname
    .replace(`${DOMAIN_APP_PREFIX}.`, '')
    .replace(`.${DOMAIN_APP_SUFFIX}`, '');
}

export function isQAEnvironment() {
  return !!getEnvironmentFromCurrentHost().match('qa[1-9][0-9]*');
}
